import Usuario from '@/spa/usuario/CadastroUsuario';
import UsuarioFornecedorDadosSensiveis from '../../../spa/usuario/UsuarioFornecedorDadosSensiveis';
import TermoAceiteUsuario from '../../../spa/termo-aceite/TermoAceiteUsuario';

const UsuarioFornecedorFormNovo = () => import('@/spa/usuario/UsuarioFornecedorFormNovo');
const UsuarioFornecedorList = () => import('@/spa/usuario/UsuarioFornecedorList');

export default {
  path: 'usuario-fornecedor-novo',
  component: Usuario,
  children: [
    {
      path: '',
      name: 'usuario-fornecedor',
      component: UsuarioFornecedorList,
    },
    {
      path: ':id/editar',
      name: 'editarUsuarioFornecedorNovo',
      component: UsuarioFornecedorFormNovo,
      props: {
        somenteLeitura: false,
      },
    },
    {
      path: ':id/editar-dados-sensiveis',
      name: 'editarDadosSensiveisUsuarioFornecedor',
      component: UsuarioFornecedorDadosSensiveis,
      props: {
        somenteLeitura: false,
      },
    },
    {
      path: 'termo-uso/:idAceite',
      name: 'verAceiteTermoUso',
      component: TermoAceiteUsuario,
    },
    {
      path: 'termo-nomeacao/:idAceite',
      name: 'verAceiteTermoNomeacao',
      component: TermoAceiteUsuario,
    },
    {
      path: 'novo',
      name: 'novoUsuarioFornecedorNovo',
      component: UsuarioFornecedorFormNovo,
    },
    {
      path: ':id',
      name: 'verUsuarioFornecedorNovo',
      component: UsuarioFornecedorFormNovo,
      props: {
        somenteLeitura: true,
      },
    },
  ],
};
